import React from 'react';

import { IconArrowBack } from '../../foundations/Iconography/IconArrowBack';
import { IconArrowForward } from '../../foundations/Iconography/IconArrowForward';
import type { RoundButtonProps } from './RoundButton/RoundButton';
import { RoundButton } from './RoundButton/RoundButton';
import * as styles from './styles';
import { ACTION_BUTTON_SIZE_MAP } from 'client-ribbons-design-system/constants/actionButtons';
import type { ActionButtonSize } from 'client-ribbons-design-system/types/actionButtons';

export interface ArrowButtonProps extends RoundButtonProps {
  direction: 'left' | 'right';
  size: ActionButtonSize;
}

/** @deprecated use `IconButton` instead */
export const ArrowButton = ({ direction, size, ...props }: ArrowButtonProps) => {
  const iconSize = ACTION_BUTTON_SIZE_MAP[size];
  const className = props.disabled ? styles.iconDisabled : undefined;

  return (
    <RoundButton size={size} {...props}>
      {direction === 'left' ? (
        <IconArrowBack css={className} height={iconSize} width={iconSize} />
      ) : (
        <IconArrowForward css={className} height={iconSize} width={iconSize} />
      )}
    </RoundButton>
  );
};
